import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessDetailResponse } from '../models/business-detail.model';
import { fromGetBusinessDetailsActions } from '../actions';

export const getBusinessDetailsFeatureKey = 'getBusinessDetails';

export interface GetBusinessDetailsState {
  loadGetBusinessDetailsResponse: IBusinessDetailResponse[];
  loadGetBusinessDetailsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: GetBusinessDetailsState = {
  loadGetBusinessDetailsResponse: undefined,
  loadGetBusinessDetailsFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(fromGetBusinessDetailsActions.loadGetBusinessDetailsSuccess, (state, action) => ({
    ...state,
    loadGetBusinessDetailsResponse: action.response,
    loaded: true
  })),
  on(fromGetBusinessDetailsActions.loadGetBusinessDetailsFailure, (state, action) => ({
    ...state,
    loadGetBusinessDetailsFailure: action.error,
    loaded: true
  })),
  on(fromGetBusinessDetailsActions.clearGetBusinessDetailsResponse, (state, action) => ({
    ...state,
    loadGetBusinessDetailsResponse: undefined,
    loaded: false
  }))
);

export const getBusinessDetailsResponse = (state: GetBusinessDetailsState) => state.loadGetBusinessDetailsResponse;
export const getBusinessDetailsIsLoaded = (state: GetBusinessDetailsState) => state.loaded;
